import { render, staticRenderFns } from "./manpower.vue?vue&type=template&id=8d01e754&scoped=true&"
import script from "./manpower.vue?vue&type=script&lang=js&"
export * from "./manpower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d01e754",
  null
  
)

export default component.exports